import { createApp } from "vue"

import HelloVue from "../components/HelloVue.vue"
import AppFooter from "../components/AppFooter.vue"
import AppDialog from "../components/AppDialog.vue"
import AppIcon from "../components/AppIcon.vue"
import AppSidebarMenu from "../components/AppSidebarMenu.vue"
import AppStatusShell from "../components/AppStatusShell.vue"
import AppTopNav from "../components/AppTopNav.vue"
import AllVmListFilter from "../components/AllVmListFilter.vue"
import AllVmTemplateFilter from "../components/AllVmTemplateFilter.vue"
import EvpnPeerStatusTable from "../components/EvpnPeerStatusTable.vue"
import EvpnRouteTable from "../components/EvpnRouteTable.vue"
import HyperVisorListResults from "../components/HyperVisorListResults.vue"
import HyperVisorFormControls from "../components/HyperVisorFormControls.vue"
import HyperVisorFormPage from "../components/HyperVisorFormPage.vue"
import HyperVisorMigrateFilter from "../components/HyperVisorMigrateFilter.vue"
import HyperVisorMigrateResults from "../components/HyperVisorMigrateResults.vue"
import HyperVisorSyncResults from "../components/HyperVisorSyncResults.vue"
import IsoImageFilter from "../components/IsoImageFilter.vue"
import IsoImageResults from "../components/IsoImageResults.vue"
import MyVmTabs from "../components/MyVmTabs.vue"
import NetworkTabs from "../components/NetworkTabs.vue"
import NetworkFormControls from "../components/NetworkFormControls.vue"
import NetworkFormPage from "../components/NetworkFormPage.vue"
import Nat46AddressList from "../components/Nat46AddressList.vue"
import Nat46FormPage from "../components/Nat46FormPage.vue"
import NetworkVmResults from "../components/NetworkVmResults.vue"
import OsTypeSelect from "../components/OsTypeSelect.vue"
import SerialConsolePage from "../components/SerialConsolePage.vue"
import StorageFormPage from "../components/StorageFormPage.vue"
import UserFormControls from "../components/UserFormControls.vue"
import UserCreateForm from "../components/UserCreateForm.vue"
import UserListResults from "../components/UserListResults.vue"
import VmDetailModal from "../components/VmDetailModal.vue"
import VmDetailPanel from "../components/VmDetailPanel.vue"
import VmImageDetailModal from "../components/VmImageDetailModal.vue"
import VmImageDetailPanel from "../components/VmImageDetailPanel.vue"
import VmImageFilter from "../components/VmImageFilter.vue"
import VmImageFormPage from "../components/VmImageFormPage.vue"
import VmImageTabs from "../components/VmImageTabs.vue"
import VmFormPage from "../components/VmFormPage.vue"
import VmListFilter from "../components/VmListFilter.vue"
import VmListResults from "../components/VmListResults.vue"
import VmSnapshotListPage from "../components/VmSnapshotListPage.vue"
import VmMigrateModal from "../components/VmMigrateModal.vue"
import VmSyncResults from "../components/VmSyncResults.vue"
import VmTemplateResults from "../components/VmTemplateResults.vue"
import VmTemplateFilter from "../components/VmTemplateFilter.vue"
import VxlanFormPage from "../components/VxlanFormPage.vue"

const registry = {
  "app-footer": AppFooter,
  "app-dialog": AppDialog,
  "app-icon": AppIcon,
  "app-sidebar-menu": AppSidebarMenu,
  "app-status-shell": AppStatusShell,
  "app-top-nav": AppTopNav,
  "hello-vue": HelloVue,
  "all-vm-list-filter": AllVmListFilter,
  "all-vm-template-filter": AllVmTemplateFilter,
  "evpn-peer-status-table": EvpnPeerStatusTable,
  "evpn-route-table": EvpnRouteTable,
  "hyper-visor-list-results": HyperVisorListResults,
  "hyper-visor-form-controls": HyperVisorFormControls,
  "hyper-visor-form-page": HyperVisorFormPage,
  "hyper-visor-migrate-filter": HyperVisorMigrateFilter,
  "hyper-visor-migrate-results": HyperVisorMigrateResults,
  "hyper-visor-sync-results": HyperVisorSyncResults,
  "iso-image-filter": IsoImageFilter,
  "iso-image-results": IsoImageResults,
  "my-vm-tabs": MyVmTabs,
  "network-tabs": NetworkTabs,
  "network-form-controls": NetworkFormControls,
  "network-form-page": NetworkFormPage,
  "nat46-address-list": Nat46AddressList,
  "nat46-form-page": Nat46FormPage,
  "network-vm-results": NetworkVmResults,
  "os-type-select": OsTypeSelect,
  "serial-console-page": SerialConsolePage,
  "storage-form-page": StorageFormPage,
  "user-form-controls": UserFormControls,
  "user-create-form": UserCreateForm,
  "user-list-results": UserListResults,
  "vm-detail-modal": VmDetailModal,
  "vm-detail-panel": VmDetailPanel,
  "vm-image-detail-modal": VmImageDetailModal,
  "vm-image-detail-panel": VmImageDetailPanel,
  "vm-image-filter": VmImageFilter,
  "vm-image-form-page": VmImageFormPage,
  "vm-image-tabs": VmImageTabs,
  "vm-form-page": VmFormPage,
  "vm-list-filter": VmListFilter,
  "vm-list-results": VmListResults,
  "vm-snapshot-list-page": VmSnapshotListPage,
  "vm-migrate-modal": VmMigrateModal,
  "vm-sync-results": VmSyncResults,
  "vm-template-results": VmTemplateResults,
  "vm-template-filter": VmTemplateFilter,
  "vxlan-form-page": VxlanFormPage
}

function collectProps(element) {
  const inlineJson = element.querySelector("[data-vue-props-json]")

  if (inlineJson) {
    try {
      return JSON.parse(inlineJson.textContent)
    } catch (error) {
      console.warn("Failed to parse inline vue props JSON", error)
      return {}
    }
  }

  const raw = element.dataset.vueProps

  if (!raw) {
    return {}
  }

  try {
    return JSON.parse(raw)
  } catch (error) {
    console.warn("Failed to parse data-vue-props", error)
    return {}
  }
}

function mountVueComponents() {
  document.querySelectorAll("[data-vue-component]").forEach((element) => {
    const componentName = element.dataset.vueComponent
    const component = registry[componentName]

    if (!component || element.dataset.vueMounted === "true") {
      return
    }

    createApp(component, collectProps(element)).mount(element)
    element.dataset.vueMounted = "true"
  })
}

document.addEventListener("DOMContentLoaded", mountVueComponents)
window.sccMountVueComponents = mountVueComponents

export { mountVueComponents }
